module.exports = __webpack_public_path__ + "img/BACK.46236a47.png";